export const problems = [
  { code: 1, label: "1、某种小动作（如咬指甲、吸手指、拉头发、拉衣服上的毛线）"},
  { code: 2, label: "2、对大人粗鲁无礼"},
  { code: 3, label: "3、与小朋友、同学合不来" },
  { code: 4, label: "4、容易兴奋、被激怒、冲动" },
  { code: 5, label: "5、爱指手划脚" },
  { code: 6, label: "6、吸吮或咬嚼（拇指、衣服、毯子等）" },
  { code: 7, label: "7、容易哭或者常常哭叫" },
  { code: 8, label: "8、脾气很大" },
  { code: 9, label: "9、白日梦（喜欢幻想）"},
  { code: 10, label: "10、学习困难" },
  { code: 11, label: "11、总觉得局促不安" },
  { code: 12, label: "12、害怕（新环境、陌生人、陌生地方、上学）" },
  { code: 13, label: "13、坐立不定，常常“忙碌”" },
  { code: 14, label: "14、喜欢搞破坏"},
  { code: 15, label: "15、撒谎或捏造情节" },
  { code: 16, label: "16、害羞" },
  { code: 17, label: "17、比同龄小朋友更容易闯祸"},
  { code: 18, label: "18、说话与同龄小朋友不同（像婴儿说话、口吃、语言难以理解）" },
  { code: 19, label: "19、不承认错误或归罪别人" },
  { code: 20, label: "20、喜欢争吵" },
  { code: 21, label: "21、喜欢撅嘴和生闷气" },
  { code: 22, label: "22、私下拿父母或他人的钱或东西" },
  { code: 23, label: "23、不服从或虽然做了但常常抱怨" },
  { code: 24, label: "24、优虑比别人多（忧虑、孤单、疾病、死亡）" },
  { code: 25, label: "25、做事有始无终，半途而废" },
  { code: 26, label: "26、感情易受伤害" },
  { code: 27, label: "27、恃强凌弱、霸道、欺凌别人" },
  { code: 28, label: "28、重复地做一件事"},
  { code: 29, label: "29、残忍" },
  { code: 30, label: "30、行为幼稚（自己会的事也要人帮忙，依缠别人，常需别人鼓励、支持）" },
  { code: 31, label: "31、容易分心或注意力不集中，已成为一种问题" },
  { code: 32, label: "32、头痛" },
  { code: 33, label: "33、情绪变化迅速、反应剧烈" },
  { code: 34, label: "34、不喜欢或不遵从纪律或约束" },
  { code: 35, label: "35、喜欢打架" },
  { code: 36, label: "36、与兄弟姐妹不能较好相处" },
  { code: 37, label: "37、遇到困难的事容易泄气" },
  { code: 38, label: "38、打扰其他小朋友" },
  { code: 39, label: "39、总是不高兴" },
  { code: 40, label: "40、有饮食问题（食欲不佳、进食中常跑开玩耍）" },
  { code: 41, label: "41、胃" },
  { code: 42, label: "42、有睡眠问题（不易入睡、早醒、夜间起床）" },
  { code: 43, label: "43、其他疼痛（常表示这里疼痛或那里疼痛）" },
  { code: 44, label: "44、呕吐或恶心" },
  { code: 45, label: "45、感到在家庭圈子中总是被欺骗" },
  { code: 46, label: "46、自夸和吹牛" },
  { code: 47, label: "47、常假想自己受到威胁" },
  { code: 48, label: "48、有大便问题（常常腹泻、排便习惯不规则、便秘）" },
]

export const  defaultValues = {
  value1: "",
  value2: "",
  value3: "",
  value4: "",
  value5: "",
  value6: "",
  value7: "",
  value8: "",
  value9: "",
  value10: "",
  value11: "",
  value12: "",
  value13: "",
  value14: "",
  value15: "",
  value16: "",
  value17: "",
  value18: "",
  value19: "",
  value20: "",
  value21: "",
  value22: "",
  value23: "",
  value24: "",
  value25: "",
  value26: "",
  value27: "",
  value28: "",
  value29: "",
  value30: "",
  value31: "",
  value32: "",
  value33: "",
  value34: "",
  value35: "",
  value36: "",
  value37: "",
  value38: "",
  value39: "",
  value40: "",
  value41: "",
  value42: "",
  value43: "",
  value44: "",
  value45: "",
  value46: "",
  value47: "",
  value48: "",
}

export const answers=[
  {code: 1, value: "没有"},
  {code: 2, value: "偶尔"},
  {code: 3, value: "常常"},
  {code: 4, value: "总是"},
]

